import { Select, SelectProps } from '@mantine/core';
import { TextureFormatOption, allTextureFormatOptions } from '../utils/getAllowedTextureFormats';

export function TextureFormatSelect({
  options = allTextureFormatOptions,
  ...otherProps
}: { options?: TextureFormatOption[] } & SelectProps) {
  return (
    <Select
      comboboxProps={{ withinPortal: false }}
      label='Texture format'
      styles={{ label: { fontWeight: 600 } }}
      data={options}
      {...otherProps}
    />
  );
}
